import { TranslationsType } from "@/app/translations/Translations";

export const T_Admin: TranslationsType = {
  USERS: {
    EN_US: "Users",
    FR_FR: "Utilisateurs",
  },
  ADD_USER: {
    EN_US: "Add user",
    FR_FR: "Ajouter un utilisateur",
  },
  EDIT_USER: {
    EN_US: "Edit user",
    FR_FR: "Modifier l'utilisateur",
  },
  DELETE_USER: {
    EN_US: "Delete user",
    FR_FR: "Supprimer l'utilisateur",
  },
  CONFIRM_DELETE_USER: {
    EN_US: "This user and all their data will be permanently deleted.",
    FR_FR: "Cet utilisateur et toutes ses données seront définitivement supprimés.",
  },
  ADMIN_VIEW: {
    EN_US: "Admin",
    FR_FR: "Admin",
  },
  PRO_VIEW: {
    EN_US: "Pro",
    FR_FR: "Pro",
  },
  PRACTICE_NOT_CONFIGURED: {
    EN_US: "Practice not configured",
    FR_FR: "Cabinet non configuré",
  },
  ADD_AS_PRACTITIONER: {
    EN_US: "Add as practitioner",
    FR_FR: "Ajouter comme praticien",
  },
  PRACTICE_NAME: {
    EN_US: "Practice name",
    FR_FR: "Nom du cabinet",
  },
  PRACTICE_ADDRESS: {
    EN_US: "Address",
    FR_FR: "Adresse",
  },
  PRACTICE_CITY: {
    EN_US: "City",
    FR_FR: "Ville",
  },
  PRACTICE_POSTAL_CODE: {
    EN_US: "Postal code",
    FR_FR: "Code postal",
  },
  PRACTICE_COUNTRY: {
    EN_US: "Country",
    FR_FR: "Pays",
  },
  USER_PENDING: {
    EN_US: "Invitation pending",
    FR_FR: "Invitation en attente",
  },
  INVITE_USER_SENT: {
    EN_US: "Invitation sent",
    FR_FR: "Invitation envoyée",
  },
  USER_ADDED: {
    EN_US: "User added",
    FR_FR: "Utilisateur ajouté",
  },
  USER_ACTIVE: {
    EN_US: "Active",
    FR_FR: "Actif",
  },
  USER_NO_INVITE_SENT: {
    EN_US: "No invitation sent",
    FR_FR: "Invitation non envoyée",
  },
  SEND_INVITATION: {
    EN_US: "Send invitation",
    FR_FR: "Envoyer l'invitation",
  },
  RESEND_INVITATION: {
    EN_US: "Resend invitation",
    FR_FR: "Renvoyer l'invitation",
  },
  INVITE_OR_SKIP: {
    EN_US: "Do you want to send an invitation email?",
    FR_FR: "Souhaitez-vous envoyer un email d'invitation ?",
  },
  SKIP: {
    EN_US: "Skip",
    FR_FR: "Passer",
  },
  USER_EMAIL_PENDING: {
    EN_US: "Email to confirm",
    FR_FR: "Email à confirmer",
  },
  EMAIL_CONFIRM_EMAIL_TITLE: {
    EN_US: "Confirm your new email address",
    FR_FR: "Confirmez votre nouvelle adresse email",
  },
  EMAIL_CONFIRM_EMAIL_TEXT: {
    EN_US:
      "Your email address has been updated. Please confirm your new address by clicking the link below.",
    FR_FR:
      "Votre adresse email a été mise à jour. Veuillez confirmer votre nouvelle adresse en cliquant sur le lien ci-dessous.",
  },
  EMAIL_CONFIRM_EMAIL_ACTION: {
    EN_US: "Confirm my email address",
    FR_FR: "Confirmer mon adresse email",
  },
  CONFIRM_EMAIL_LOADING: {
    EN_US: "Confirming your email address...",
    FR_FR: "Confirmation de votre adresse email...",
  },
  CONFIRM_EMAIL_SUCCESS: {
    EN_US: "Email confirmed! Redirecting...",
    FR_FR: "Email confirmé ! Redirection...",
  },
  CONFIRM_EMAIL_ERROR: {
    EN_US: "This confirmation link is invalid or has already been used.",
    FR_FR: "Ce lien de confirmation est invalide ou a déjà été utilisé.",
  },
  USERS_EMPTY: {
    EN_US: "No users have been added yet.\nAdd the first user to get started.",
    FR_FR:
      "Aucun utilisateur n'a encore été ajouté.\nAjoutez le premier utilisateur pour commencer.",
  },
};
